import deepmerge from 'deepmerge';
import { FragmentConfig } from '@/config/types';
import config from './default';
import { DeepPartial } from './deeppartial';

export const tenantConfig: DeepPartial<FragmentConfig> = {
  apiParams: {
    values: {
      apiDefaultParams: {
        channel: 'web',
        clientId: 'JelmoliCh',
        clientShortId: 'jch',
        locale: 'de-CH',
        localeApi: 'de',
        localesToSwitch: ['de-CH', 'fr-CH'],
        useNewApi: true,
      },
      apiAssetManagement: {
        path: 'https://media.jelmoli-shop.ch',
      },
    },
  },
  currency: { sign: 'CHF', locale: 'fr-CH' },
  routingPaths: {
    exact: ['/', '/fr', '/fr/'],
  },
  headerInformation: {
    de: {
      description:
        'Entdecken Sie aktuelle Fashion- und Wohntrends. Grosse Auswahl ✔ Top-Brands ✔ Gratis Versand & Retoure ✔ Machen Sie sich eine Freude!',
      title: 'Jelmoli Versand - der online Mode und Möbel Versand',
      canonical: 'https://www.jelmoli-shop.ch',
      robots: 'index,follow',
    },
    fr: {
      description:
        "Description:* Mode et meubles à commander SUR FACTURE - robes, chaussures, lingerie, maillots, sport, meubles et articles techniques. L'embarras du choix sur JELMOLI VERSAND SUISSE",
      title: 'Jelmoli Versand Suisse - vente de mode et meubles à distance',
      canonical: 'https://www.jelmoli-shop.ch',
      robots: 'index,follow',
    },
  },
  tracking: {
    schemaOrgOrganisation: {
      areaServed: 'CH',
      email: 'service@jelmoliversand.ch',
      hoursAvailable: 'Täglich zwischen 7 bis 22.00 Uhr – auch an Wochenenden und Feiertagen',
      logo: `/assets/logos/${config?.global?.values?.FRAGMENT_COMPANYID}/logo.svg`,
      name: 'Jelmoli Versand',
      productSupported: '(Festnetz CHF 0.14 / Min., Mobilfunkpreise max. CHF 0.42 / Min.)',
      sameAs: [
        '"http://www.facebook.com/jelmolishop/"',
        '"https://www.youtube.com/user/JelmoliShop"',
      ],
      telephone: '+41848-840-300',
      url: 'https://www.jelmoli-shop.ch',
      potentialAction: {
        target: 'https://www.jelmoli-shop.ch/s/{search_term}/',
      },
    },
    values: {
      googleSiteVerification: 'fZ1lyGUwe-g4AMGjHievvd2bqXuyPGQGB-lX4odp2pM',
      msvalidate01: '4067315BE5669CD6C74BDEC6F6AC5D47',
      siteName: '@EmpirieCom-JelmoliCH',
      soastaId: 'E5TKR-EUQHN-KSJKK-TGX8P-4US3H',
    },
  },
  apiAgnitasUrl: {
    values: {
      useDOI: false,
    },
  },
};

export default deepmerge(config, tenantConfig) as FragmentConfig;
